import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { OrderResource } from "@exonn/js-sdk";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import type { RouteObject } from "react-router-dom";

const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.Order,
});
const createRouteObject = {
  path: routePaths.create.root,
  lazy: () =>
    import(
      "src/admin/modules/order/routes/create/create-order/create.general.tsx"
    ),
};

const ticketsRoute: RouteObject = {
  lazy: () =>
    import(
      "src/admin/modules/order/routes/edit/tabs/tickets/tickets.route.tsx"
    ),
};

export const module: ModuleOptions<OrderResource> = {
  resource: ResourceEnum.Order,
  smallIcon: <i className={"icon-15-custm_ord"} />,
  bigIcon: <i className={"icon-20-custm_ord"} />,

  disableDelete: true,
  create: {
    routeObject: createRouteObject,
  },
  tabs: {
    edit: {
      titleProp: "number",
    },
  },

  formTabs: {
    general: {
      title: (t) => t("tabs.general"),
    },
    address: {
      title: (t) => t("tabs.address"),
    },
    positions: {
      title: (t) => t("tabs.positions"),
    },
    shipping: {
      title: (t) => t("tabs.shipping"),
    },
    tickets: {
      title: (t) => t("tabs.tickets"),
      isHidden: ({ data, globalSettings }) =>
        !globalSettings.event_tickets_enabled ||
        !(
          "event_tickets" in
          ((
            data as
              | (OrderResource & { meta?: Record<string, unknown> })
              | undefined
          )?.meta ?? {})
        ),
      routeObject: ticketsRoute,
    },
    post: {
      title: (t) => t("tabs.post"),
    },
  },
};
